import { LineChart, BarChart, ChartContainer } from '../Charts';
import dayjs from 'dayjs';

const ChargerChart = ({
  type, // '24hours', '2weeks', '1year'
  isLoadingA,
  isLoadingB,
  error,
  chargingHistoryTimeSlotA,
  chargingHistoryTimeSlotB,
  periodChargerStatTwoWeeksA,
  periodChargerStatTwoWeeksB,
  periodChargerStatOneYearA,
  periodChargerStatOneYearB,
  chargerA,
  chargerB,
}) => {
  const today = dayjs().format('YYYY-MM-DD');
  const twoWeeksAgo = dayjs().subtract(14, 'day').format('YYYY-MM-DD');
  const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
  
  const isLoading = isLoadingA || isLoadingB;
  
  // 24시간 차트 데이터
  const get24HoursData = () => {
    const labels = chargingHistoryTimeSlotA?.map(item => {
      let time = item.SlotStartTime?.split('T')[1];
      time = time.split(':');
      time = time[0] + ':' + time[1];
      return time;
    }) || chargingHistoryTimeSlotB?.map(item => {
      let time = item.SlotStartTime?.split('T')[1];
      time = time.split(':');
      time = time[0] + ':' + time[1];
      return time;
    }) || [];
    
    const datasets = [];
    
    if (chargerA && chargingHistoryTimeSlotA) {
      datasets.push({
        label: `충전기 A (${chargerA.CpoChargerId})`,
        data: chargingHistoryTimeSlotA.map(item => item.AoC/1000),
        borderColor: '#2563EB',
        backgroundColor: '#2563EB',
        fill: false,
        tension: 0.1
      });
    }
    
    if (chargerB && chargingHistoryTimeSlotB) {
      datasets.push({
        label: `충전기 B (${chargerB.CpoChargerId})`,
        data: chargingHistoryTimeSlotB.map(item => item.AoC/1000),
        borderColor: '#10B981',
        backgroundColor: '#10B981',
        fill: false,
        tension: 0.1
      });
    }
    
    return { labels, datasets };
  };
  
  // 2주 차트 데이터
  const get2WeeksData = () => {
    const labels = periodChargerStatTwoWeeksA?.map(item => {
      let time = item.Date?.split('T')[0];
      return time;
    }) || periodChargerStatTwoWeeksB?.map(item => {
      let time = item.Date?.split('T')[0];
      return time;
    }) || [];
    
    const datasets = [];
    
    if (chargerA && periodChargerStatTwoWeeksA) {
      datasets.push({
        label: `충전기 A 전력량 (kWh)`,
        data: periodChargerStatTwoWeeksA.map(item => item.TotalAoC/1000),
        borderColor: '#2563EB',
        backgroundColor: '#2563EB',
        fill: false,
        tension: 0.1
      });
    }
    
    if (chargerB && periodChargerStatTwoWeeksB) {
      datasets.push({
        label: `충전기 B 전력량 (kWh)`,
        data: periodChargerStatTwoWeeksB.map(item => item.TotalAoC/1000),
        borderColor: '#10B981',
        backgroundColor: '#10B981',
        fill: false,
        tension: 0.1
      });
    }
    
    return { labels, datasets };
  };
  
  // 1년 차트 데이터
  const get1YearData = () => {
    const labels = periodChargerStatOneYearA?.map(item => {
      let time = item.Date?.split('T')[0];
      let yearMonth = time.split('-')[0] + '-' + time.split('-')[1];
      return yearMonth;
    }) || periodChargerStatOneYearB?.map(item => {
      let time = item.Date?.split('T')[0];
      let yearMonth = time.split('-')[0] + '-' + time.split('-')[1];
      return yearMonth;
    }) || [];
    
    const datasets = [];
    
    if (chargerA && periodChargerStatOneYearA) {
      datasets.push({
        label: `충전기 A 전력량 (kWh)`,
        data: periodChargerStatOneYearA.map(item => item.TotalAoC/1000),
        borderColor: '#2563EB',
        backgroundColor: '#2563EB',
        fill: false,
        tension: 0.1
      });
    }
    
    if (chargerB && periodChargerStatOneYearB) {
      datasets.push({
        label: `충전기 B 전력량 (kWh)`,
        data: periodChargerStatOneYearB.map(item => item.TotalAoC/1000),
        borderColor: '#10B981',
        backgroundColor: '#10B981',
        fill: false,
        tension: 0.1
      });
    }
    
    return { labels, datasets };
  };
  
  const getChartData = () => {
    switch (type) {
      case '24hours':
        return get24HoursData();
      case '2weeks':
        return get2WeeksData();
      case '1year':
        return get1YearData();
      default:
        return { labels: [], datasets: [] };
    }
  };
  
  const getTitle = () => {
    switch (type) {
      case '24hours':
        return '충전기 과거 24시간 충전 이력';
      case '2weeks':
        return '충전기 과거 2주 통계';
      case '1year':
        return '충전기 과거 1년 통계';
      default:
        return '';
    }
  };
  
  const getSubtitle = () => {
    switch (type) {
      case '24hours':
        return `집계 기준 : ${yesterday} 00:00 ~ 23:59`;
      case '2weeks':
        return `집계 기준 : ${twoWeeksAgo} ~ ${today}`;
      case '1year':
        return `집계 기준 : ${twoWeeksAgo} ~ ${today}`;
      default:
        return '';
    }
  };
  
  const hasData = () => {
    switch (type) {
      case '24hours':
        return (chargingHistoryTimeSlotA && chargingHistoryTimeSlotA.length > 0) || 
               (chargingHistoryTimeSlotB && chargingHistoryTimeSlotB.length > 0);
      case '2weeks':
        return (periodChargerStatTwoWeeksA && periodChargerStatTwoWeeksA.length > 0) || 
               (periodChargerStatTwoWeeksB && periodChargerStatTwoWeeksB.length > 0);
      case '1year':
        return (periodChargerStatOneYearA && periodChargerStatOneYearA.length > 0) || 
               (periodChargerStatOneYearB && periodChargerStatOneYearB.length > 0);
      default:
        return false;
    }
  };
  
  const chartData = getChartData();
  
  return (
    <div className='flex flex-col gap-10 mb-20'>
      <h3 className='text-b1-700 text-base'>{getTitle()}</h3>
      <p className='text-b2-700 text-gray-600'>{getSubtitle()}</p>
      <ChartContainer
        isLoading={isLoading}
        error={error}
        hasData={hasData()}
        loadingText="충전 이력을 불러오는 중..."
        errorText="충전 이력을 불러오는데 실패했습니다"
        noDataText="충전 이력 데이터가 없습니다"
        height="400px"
      >
        {type === '24hours' ? (
          <LineChart
            data={chartData}
            title="24시간 전력 수요 추이"
            height="380px"
          />
        ) : (
          <BarChart
            data={chartData}
            title="전력 수요 추이"
            height="380px"
            maxTicksLimit={type === '2weeks' ? 14 : 12}
          />
        )}
      </ChartContainer>
    </div>
  )
}

export default ChargerChart
